export const composeValidators = (...validators) => (value, values) =>
  validators.reduce((error, validator) => error || validator(value, values), undefined)

const VALIDTHRU_REGEX = /^(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/ // MM/yyyy

export const validateExpireDate = date =>
  VALIDTHRU_REGEX.test(date) ? undefined : 'Padrão obrigatório MM/YYYY'

export const validateAmexCVV = value => (value.length < 4 ? `No mínimo 4 dígitos` : undefined)

export const validateCVV = value => (value.length < 3 ? `No mínimo 3 dígitos` : undefined)

export const required = value => (value ? undefined : 'Campo Obrigatório')



// WEBPACK FOOTER //
// ./src/utils/validators.js